import stepOne from "./stepOne";
import stepTwo from "./stepTwo";
import stepThree from "./stepThree";

const quotationFields = { stepOne, stepTwo, stepThree };

export default quotationFields;
